export default __webpack_public_path__ + "static/5c7414c6ec2461f410fb5d8826684935.jpeg";